import { useThemeValidationContext } from '#theme';
import { DatiSessioneUtente } from '@framework/api-client';
import { useMemo } from 'react';
import { ISessionData } from './ISessionData';
import { getSessionValidationContext } from './getSessionValidationContext';

/**
 * @deprecated Vedere useEngineValidationContext
 */
export function useSessionValidationContext(user: DatiSessioneUtente | null) {
  const themeData = useThemeValidationContext();

  const sessionData: ISessionData = useMemo(
    () => ({
      ...getSessionValidationContext(user?.utenteLoggato),
      // Aggiungo ai dati della sessione anche i dati del tema
      ...themeData,
    }),
    [themeData, user?.utenteLoggato],
  );

  return sessionData;
}
